import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'
import smoothscroll from 'smoothscroll-polyfill'
import config from './config'
import HttpPlugin from '@advisr/frontend-ui-components/src/plugins/HttpPlugin'
import CurrencyFormatter from '@advisr/frontend-ui-components/src/plugins/CurrencyFormatter'
import ErrorTracking from '@advisr/frontend-ui-components/src/plugins/ErrorTracking'
import Vue2TouchEvents from 'vue2-touch-events'
import * as formatters from '@advisr/frontend-ui-components/src/utils/formatters'

// CSS imports
import '@advisr/frontend-ui-components/src/assets/global.css'
import '@advisr/frontend-ui-components/src/assets/css/presentation-fonts.css'
import './assets/styles/global.css'

smoothscroll.polyfill()

Vue.use(HttpPlugin)

Vue.config.productionTip = false

// Add formatters to Vue prototype
Vue.prototype.$formatNumberWithCommas = formatters.formatNumberWithCommas
Vue.prototype.$formatShortDate = formatters.formatShortDate

Vue.use(CurrencyFormatter)
Vue.use(ErrorTracking, config.rollbar)
Vue.use(Vue2TouchEvents)

// Analytics
const useAnalytics = (
  config.google &&
  config.google.analytics &&
  config.google.analytics.apiKey &&
  config.google.analytics.apiKey !== ''
)

if (useAnalytics) {
  Vue.use(VueGtag, {
    config: { id: config.google.analytics.apiKey },
    pageTrackerTemplate (to) {
      return {
        page_title: `Presentation: ${to.name}`,
        page_path: to.path,
        page_location: window.location.href
      }
    }
  }, router)
}

export const vm = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
